<template>
  <div class="footer-basic">
    <footer>
        <div class="social">
          <!-- not really sure what #stuff is -->
          <a href="mailto:hello@teachtechnc.com">&#128233;</a>
          <!-- other social icons can go here when we have them -->
        </div>
        <ul class="list-inline">
          <router-link class="list-inline-item" to="/">HOME &nbsp;</router-link>
            <router-link to="/about"> ABOUT &nbsp;</router-link>
            <router-link to="/#"> &nbsp;SIGN UP&nbsp;&nbsp;</router-link>
            <a href="mailto:hello@teachtechnc.com">&nbsp;CONTACT</a><br/>
        </ul>
        <div id="cc">
          <a rel="license" href="http://creativecommons.org/licenses/by/4.0/"><img alt="Creative Commons License" style="border-width:0" src="https://i.creativecommons.org/l/by/4.0/88x31.png" /></a><br/>
          This work is licensed under a <a rel="license" href="http://creativecommons.org/licenses/by/4.0/">Creative Commons Attribution 4.0 International License</a>.
        </div>
    </footer>
  </div>
</template>

<script>
export default {
    name: 'Footer',
};
</script>

<style scoped>
.footer-basic {
  background-color: #333333;
  color: #a8a7a8;
  position: absolute;
  left: 0;
  bottom: 0px;
  height: 250px;
  width: 100%;
  overflow: hidden;
  padding: 20px;
}

.footer-basic a {
  color: #a8a7a8;
}

.footer-basic ul {
  padding: 0;
  list-style: none;
  text-align: center;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 0;
}

.footer-basic li {
  padding: 0 10px;
}

.footer-basic ul a {
  color: inherit;
  text-decoration: none;
  font-weight: bold;
  opacity: 0.8;
}

.footer-basic ul a:hover {
  opacity: 1;
}

.footer-basic .social {
  text-align: center;
  padding-bottom: 25px;
}

.footer-basic .social > a {
  font-size: 24px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin: 0 8px;
  color: inherit;
  opacity: 0.75;
}

.footer-basic .social > a:hover {
  opacity: 0.9;
}

#cc {
  text-align: left;
  width: 50%;
  padding: 0 10vw 0 10vw;
  color: #8eb7af;
  position: relative;
  top: 20px;
  left: 0;
  bottom: 10px;
  height: 50px;
}

#cc > a {
  color: #8eb7af;
  font-weight: bold;
}

@media only screen and (max-width: 800px) {
  #cc {
    width: 80%;
    font-size: 12px;
  }
}

@media only screen and (max-width: 500px) {
  #cc {
    width: 100%;
  }
}
</style>
